import { useLayoutEffect } from 'react'

let width = 0
let runningCalculation

export const useViewportUnit = () => {
	useLayoutEffect(() => {
		const calculateViewportUnit = () => {
			if (window.innerWidth !== width) {
				const vh = window.innerHeight * 0.01
				document.documentElement.style.setProperty('--vh', `${vh}px`)
				width = window.innerWidth
			}
		}
		const throttledCalculation = () => {
			clearTimeout(runningCalculation)
			runningCalculation = setTimeout(calculateViewportUnit, 100)
		}
		calculateViewportUnit()
		window.addEventListener('resize', throttledCalculation)
		return () => {
			document.documentElement.style.removeProperty('--vh')
			window.removeEventListener('resize', throttledCalculation)
		}
	}, [])
}
